/**
 * 문자열에서 숫자만 추출하고 적절한 단위를 붙여주는 함수
 * @param value - 입력 문자열 (예: "100px", "100", "abc100def", "100.5px", "50%")
 * @param defaultValue - 숫자가 없을 때 기본값 (기본값: "0")
 * @returns 숫자 + 적절한 단위 형태의 문자열 (예: "100px", "50%")
 */
export function formatPixelValue(value: string | number | undefined, defaultValue: string = "0"): string {
    if (typeof value === 'number') {
        return `${value}px`;
    }

    if (!value || typeof value !== 'string') {
        return `${defaultValue}px`;
    }

    // 퍼센테이지 체크 - %가 포함되어 있으면 숫자만 추출하고 %를 붙임
    if (value.includes('%')) {
        const numberMatch = value.match(/\d+(\.\d+)?/);
        if (numberMatch) {
            const extractedNumber = numberMatch[0];
            return `${extractedNumber}%`;
        }
        // 퍼센테이지 기호는 있지만 숫자가 없으면 기본값에 % 붙임
        return `${defaultValue}%`;
    }

    // 문자열에서 숫자만 추출 (소수점 포함)
    const numberMatch = value.match(/\d+(\.\d+)?/);

    if (numberMatch) {
        const extractedNumber = numberMatch[0];
        return `${extractedNumber}px`;
    }

    // 숫자가 없으면 기본값 반환
    return `${defaultValue}px`;
}

/**
 * 픽셀 또는 퍼센테이지 값에서 숫자만 추출하는 함수
 * @param value - 값 문자열 (예: "100px", "100", "50%")
 * @returns 숫자 (예: 100, 50)
 */
export function extractPixelNumber(value: string): number {
    if (!value || typeof value !== 'string') {
        return 0;
    }

    const numberMatch = value.match(/\d+(\.\d+)?/);
    return numberMatch ? parseFloat(numberMatch[0]) : 0;
}

/**
 * 값이 퍼센테이지인지 확인하는 함수
 * @param value - 확인할 값
 * @returns 퍼센테이지 여부
 */
export function isPercentage(value: string): boolean {
    return typeof value === 'string' && value.includes('%');
} 